<template>
    <div class="row" v-if="isTimeSet">
        <div class="col-md-12 text-center">
            <div class="special-card w-100 border-0" style="width: 18rem;">
                <div class="card-body">
                    <h5 style="margin-top: 16px;">{{ cityDatetime.current_date }}</h5>
                    <h2 style="margin: 0; padding: 0 !important;">{{ hours }}:{{ minutes }}:{{ seconds }} {{ ampm }}</h2>
                    <p><small>{{ cityDatetime.timezone_formatted }} ({{ cityDatetime.timezone_gmt_offset }} / {{ cityDatetime.timezone_dst_offset }})</small></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { pad } from '@/utils/format'

export default {
    name: 'CityTime',
    data() {
        return {
            hours: null,
            minutes: null,
            seconds: null,
            ampm: 'am',
            isTimeSet: false,
            mountedAt: null,
            intervalId: null,
        }
    },
    computed: {
        ...mapState(['city', 'cityDatetime']),
    },
    watch: {
        city() {
            this.mountedAt = new Date()
        },
        cityDatetime() {
            this.tick()
        },
    },
    methods: {
        ...mapMutations(['setTime']),
        tick() {
            if (!this.cityDatetime) return
            const elapsedSeconds = Math.round((new Date() - this.mountedAt) / 1000)
            const cityTime = new Date(
                this.cityDatetime.current_year,
                this.cityDatetime.current_month - 1,
                this.cityDatetime.current_day,
                this.cityDatetime.current_hours,
                this.cityDatetime.current_minutes,
                this.cityDatetime.current_seconds,
            )
            cityTime.setSeconds(cityTime.getSeconds() + elapsedSeconds)
            this.setTime(cityTime)
            const h = cityTime.getHours()
            this.ampm = h >= 12 ? 'pm' : 'am'
            this.hours = pad(h > 12 ? h % 12 || 12 : h, 2)
            this.minutes = pad(cityTime.getMinutes(), 2)
            this.seconds = pad(cityTime.getSeconds(), 2)
            this.isTimeSet = true
        },
    },
    mounted() {
        this.mountedAt = new Date()
        this.intervalId = setInterval(() => this.tick(), 1000)
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
    },
}
</script>
